import { useEffect } from 'react';

export default function NotificationAlert({
  notification,
  className = '',
  origin = '',
  autoCloseMs = 5000,
  onClose,
}) {
  const hasOriginMismatch = origin && notification?.origin && notification.origin !== origin;
  const isVisible = Boolean(notification?.show) && !hasOriginMismatch;

  useEffect(() => {
    if (!isVisible || autoCloseMs == null || autoCloseMs <= 0 || typeof onClose !== 'function') {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      onClose();
    }, autoCloseMs);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isVisible, autoCloseMs, onClose, notification?.message]);

  if (!isVisible) return null;

  const isSuccess = notification.type === 'success';
  const containerClass = isSuccess
    ? 'bg-success/12 border-success text-success'
    : 'bg-error/12 border border-error text-error';

  return (
    <div className={`rounded-lg border-l-4 p-3 text-sm ${containerClass} ${className}`}>
      <div className="flex items-center space-x-3">
        <p className="font-medium whitespace-pre-line">{notification.message}</p>
      </div>
    </div>
  );
}
